import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";
import { GetWebsite } from "../interface/website";

export const getWebsites = async (
  page: number,
  limit: number
): Promise<GetWebsite> => {
  try {
    return await apiRequest<GetWebsite>("get", `/websites`, {
      params: {
        page,
        limit,
      },
    });
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch websites");
  }
};
